import React from 'react';
import { formatCurrency } from '../common/common';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

const styles = {
    warning: {
        color: 'darkred',
    },
    ok: {
        color: 'green',
    },
};

const FilterMargin = ({ filter, currency, exchangeRate }) => {
    const { t } = useTranslation();

    const getStyle = (marginPercentage) => {
        return marginPercentage > 0 ? styles.ok : styles.warning;
    };

    return (
        <React.Fragment>
            {filter.margin(exchangeRate) !== -1 && (
                <Box component="span" sx={getStyle(filter.marginPercentage(exchangeRate))}>
                    Kate {formatCurrency(filter.margin(exchangeRate), 2, currency)} ({filter.marginPercentage(exchangeRate)}%)
                </Box>
            )}
            {filter.margin(exchangeRate) === -1 && <Box component="span" sx={styles.warning}>{t('general.margin')} *</Box>}
        </React.Fragment>
    );
};

export default FilterMargin;
